'use strict';

var Hounisen = Hounisen || {};
Hounisen.navigation = new function () {

    function init() {
        // Init functions
        openSubnav();
        megamenu();
        showSpinnner();
    }

    function openSubnav() {
        $('.subnav-trigger').click(function () {
            $(this).toggleClass('subnav-trigger--rotate');
            $(this).closest('.offcanvas-navigation__item').toggleClass('offcanvas-navigation__item--open');
        });
        $('.navbar-search-button__icon--search').click(function () {
            $('.navbar-search').toggleClass('navbar-search--open');
            $('.navbar-search__field').focus();
        });
    }

    function megamenu() {
        var navigationItem = $('.megamenu .dropdown');
        navigationItem.hoverIntent({
            timeout: 350,
            over: function () { $(this).toggleClass('open'); },
            out: function () { $(this).toggleClass('open'); }
        });
    }

    function showSpinnner() {
        // Show spinner on search submit
        $(".search-section__btn button, .offcanvas-menu-search__button").on("click", function () {
            $('.js-loader').addClass('loader--show');
        });
    }


    return {
        init: init
    };
}();